import React from "react";

/**
 * Bonuszvadász Logo — clean, professional SVG mark.
 * - Crosshair / targeting reticle (utalva a "vadász" = bonusz-hunter koncepcióra)
 * - Stylized "B" monogram a középpontban
 * - Arany akcentus + sötét háttér -> komoly, prémium kinézet
 */
export default function Logo({ size = 56, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Bonuszvadász logó"
      data-testid="brand-logo-svg"
    >
      <defs>
        <linearGradient id="bvGold" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFE08A" />
          <stop offset="50%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#8C6A1A" />
        </linearGradient>
        <linearGradient id="bvDark" x1="0" y1="0" x2="0" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#2a0a0a" />
          <stop offset="60%" stopColor="#0f0606" />
          <stop offset="100%" stopColor="#0a0806" />
        </linearGradient>
        <filter id="bvShadow" x="-10%" y="-10%" width="120%" height="120%">
          <feDropShadow dx="0" dy="1" stdDeviation="1.2" floodColor="#D4AF37" floodOpacity="0.35" />
        </filter>
      </defs>

      {/* Outer shield/badge */}
      <path
        d="M32 2 L60 12 V32 C60 47 47 58 32 62 C17 58 4 47 4 32 V12 Z"
        fill="url(#bvDark)"
        stroke="url(#bvGold)"
        strokeWidth="1.75"
      />

      {/* Crosshair reticle */}
      <circle cx="32" cy="32" r="18" stroke="url(#bvGold)" strokeWidth="1.25" opacity="0.55" />
      <line x1="32" y1="11" x2="32" y2="17" stroke="url(#bvGold)" strokeWidth="1.5" />
      <line x1="32" y1="47" x2="32" y2="53" stroke="url(#bvGold)" strokeWidth="1.5" />
      <line x1="11" y1="32" x2="17" y2="32" stroke="url(#bvGold)" strokeWidth="1.5" />
      <line x1="47" y1="32" x2="53" y2="32" stroke="url(#bvGold)" strokeWidth="1.5" />

      {/* Monogram "B" — stylized */}
      <g filter="url(#bvShadow)">
        <path
          d="M24 20 H35 C39.5 20 42.5 22.4 42.5 26.2 C42.5 29 41 30.8 38.8 31.6 C41.6 32.4 43.4 34.4 43.4 37.6 C43.4 41.6 40.2 44 35.4 44 H24 Z M28.6 23.6 V30 H34.2 C36.4 30 37.8 28.8 37.8 26.8 C37.8 24.8 36.4 23.6 34.2 23.6 Z M28.6 33.4 V40.4 H34.8 C37.2 40.4 38.7 39 38.7 36.9 C38.7 34.8 37.2 33.4 34.8 33.4 Z"
          fill="url(#bvGold)"
        />
      </g>

      {/* Small star marks (premium feel) */}
      <circle cx="50.5" cy="13.5" r="1.2" fill="url(#bvGold)" />
      <circle cx="13.5" cy="13.5" r="1.2" fill="url(#bvGold)" />
    </svg>
  );
}
